// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"6":"8369c78d","38":"2f456833","318":"ec57477e","657":"ba5b0956","787":"d9312eb8"}[chunkId] + ".chunk.js";
};